import { useCallback, useEffect, useState } from "react";
import { charset, number } from "../../../shared/data";

interface IUseGeneratorPrivateHash {
    hash: string;
    onGenerateHash: () => void;
}

export const useGeneratorPrivateHash = (): IUseGeneratorPrivateHash => {
    const LENGTH_HASH_MIN = 4;
    const LENGTH_HASH_MAX = 6;

    const [hash, setHash] = useState<string>("");

    const getRandomNumber = (order: number) => {
        return Math.floor(Math.random() * order);
    }

    const onGenerateHash = useCallback(() => {
        const length = Math.floor(Math.random() * (LENGTH_HASH_MAX - LENGTH_HASH_MIN) + LENGTH_HASH_MIN);

        let hash = "";

        for (var i = 0; i <= length; ++i) {
            let target = getRandomNumber(charset.length);
            hash += charset.charAt(target);
        }

        const haveNumberPattern = /[1-9]/i;

        if (haveNumberPattern.test(hash[0])) {
            hash = hash.substring(1)
        }
        if (!haveNumberPattern.test(hash[0]) && !haveNumberPattern.test(hash)) {
            hash = hash.substring(0, hash.length - 1)
            hash += number.charAt(Math.floor(Math.random() * number.length));
        }

        setHash(hash);
    }, []);

    useEffect(() => {
        onGenerateHash();
    }, [onGenerateHash]);

    return {
        hash,
        onGenerateHash,
    }
}